import {
    GET_CALENDAR_VACATIONS,
    GET_CALENDAR_HOLIDAYS,
} from '../actions/calendar';

const INITIAL_STATE = {
    vacations: [],
    holidays: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_CALENDAR_VACATIONS:
            return Object.assign({}, state, {vacations: [].concat(action.value)});
        case GET_CALENDAR_HOLIDAYS:
            return Object.assign({}, state, {holidays: [].concat(action.value)});
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/calendar.js